<template>
  <base-modal ref="modal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Close Invitation</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to close this invition?</p>
          </div>
          <base-form ref="deleteInviteForm" class="tw-py-6 tw-w-full" v-model="isFormValid">
            <base-text-field v-model="closedReason" label="Closed Reason" required />
          </base-form>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse ">
        <base-button @click="closeInvite" :disabled="!isFormValid" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-invite-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>

<script>
import InlineError from "@/components/InlineError";
import TrashIcon from "@/assets/svgs/trash-icon.svg";

export default {
  name: "BusinessMemberInviteDelete",
  components: {
    InlineError,
    TrashIcon,
  },
  props: {
    businessId: String,
    userId: String,
  },
  data() {
    return {
      isLoading: false,
      invite: {},
      isFormValid: true,
      closedReason: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    reset() {
      this.invite = {};
    },
    show(invite) {
      this.invite = invite;
      this.$refs.deleteInviteForm.reset();
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    closeInvite() {
      if (!this.$refs.deleteInviteForm.validate()) return;

      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/members/${this.userId}/invites/${this.invite.businessMemberInviteId}/close`, { closedReason: this.closedReason })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Invitation Closed", message: "This invitation was successfully closed" });
          this.$emit("delete");
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Closure failed.`;
          this.errorMessage = `The invitation could not be closed. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
